<script lang="ts" setup>
import {
  useMicrosoftAuthorizationForPlannerAccount,
  ENTRANCE_GUID_STORAGE_KEY,
} from '@/hooks/useMicrosoftAuthorization'
import { computed, ref, watch } from 'vue'
import * as NewRelic from '@/newrelic'
import { useRoute, useRouter } from 'vue-router'
import { getQuery } from '@/libs/utilities/getQuery'

const router = useRouter()
const route = useRoute('settingsCalendarAuthCallback')

const storedEntranceGUID = sessionStorage.getItem(ENTRANCE_GUID_STORAGE_KEY)
const entranceGUID = storedEntranceGUID ?? ''

if (storedEntranceGUID) {
  sessionStorage.removeItem(ENTRANCE_GUID_STORAGE_KEY)
}

const microsoftAuthForPlannerAccount =
  useMicrosoftAuthorizationForPlannerAccount(entranceGUID)

const code = computed(() => getQuery(route.query.code))
const missingEntranceGUID = ref(false)

if (!storedEntranceGUID && code.value) {
  missingEntranceGUID.value = true
}

if (code.value && entranceGUID) {
  await microsoftAuthForPlannerAccount.storeOAuthCredential(code.value)

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({
    name: 'calendarSetting',
    params: {
      entranceGUID: entranceGUID,
    },
  })
}

const error = computed(() => getQuery(route.query.error))
const errorSubCode = computed(() => getQuery(route.query.error_subcode))

watch([error, errorSubCode], ([newError, newErrorSubCode]) => {
  if (!newError) {
    return
  }

  if (errorSubCode.value === 'cancel') {
    // cancel はユーザー起因のエラーなのでNewRelic に送らない
    return
  }

  NewRelic.captureMessage('failed to calendar auth callback.', {
    error: newError,
    ...(newErrorSubCode && { error_subcode: newErrorSubCode }),
  })
})
</script>

<template>
  <p v-if="missingEntranceGUID">
    <span>セッション情報が見つかりませんでした。</span><br />
    <span>もう一度カレンダー連携をお試しください。</span>
  </p>
  <p v-else-if="code">処理中です...</p>
  <p v-if="error">
    <span>error: {{ error }}</span
    ><br />
    <span>error_subcode: {{ errorSubCode }}</span
    ><br />
    <RouterLink
      v-if="entranceGUID"
      :to="{ name: 'calendarSetting', params: { entranceGUID: entranceGUID } }"
    >
      設定画面に戻る
    </RouterLink>
  </p>
</template>
